import { LayerIds } from "fond/layers";
import { GroupConfig } from "fond/types";
import { LayerConfig, LayerStyle, SublayerConfig } from "fond/types/ProjectLayerConfig";

import { FamilialLayerConfig, groupConfigTemplate, layerConfigTemplate } from "./configuration";

export enum BaseDataLayerId {
  ROOT = "multiProjectBaseDataGroup",
  ADDRESSES = "multiProjectAddressesLayer",
  STREETS = "multiProjectStreetsLayer",
}

/**
 * Create the Base Data configuration.
 */
export const baseDataConfiguration = (): { configs: Array<LayerConfig | LayerStyle | SublayerConfig>; groupConfig: GroupConfig } => {
  const { config: addressesConfig, descendants: addressesDescendants } = createAddressesLayer();
  const { config: streetsConfig, descendants: streetsDescendants } = createStreetsLayer();

  const baseDataGroup = groupConfigTemplate(BaseDataLayerId.ROOT, [addressesConfig, streetsConfig], "Base Data", true, "multiProjectOverlayGroup");

  return {
    configs: [...addressesDescendants, addressesConfig, ...streetsDescendants, streetsConfig],
    groupConfig: baseDataGroup,
  };
};

const createAddressesLayer = (): FamilialLayerConfig => {
  const descendants = addressesLayerStyles(BaseDataLayerId.ADDRESSES, "#7a88e6");
  const config = layerConfigTemplate(BaseDataLayerId.ADDRESSES, LayerIds.inAddress, "Addresses", descendants, [], BaseDataLayerId.ROOT);

  return { config, descendants };
};

const createStreetsLayer = (): FamilialLayerConfig => {
  const descendants = streetsLayerStyles(BaseDataLayerId.STREETS, "#808080");
  const config = layerConfigTemplate(BaseDataLayerId.STREETS, LayerIds.inBaseDataStreet, "Streets", descendants, [], BaseDataLayerId.ROOT);

  return { config, descendants };
};

const addressesLayerStyles = (layerId: string, color: string): LayerStyle[] => [
  {
    ID: `${layerId}-point`,
    Name: `${layerId}-point`,
    GlobalPosition: 1,
    ConfigurationID: layerId,
    ConfigurationType: "LAYER",
    Position: 0,
    MapboxStyle: {
      type: "circle",
      "source-layer": "default",
      paint: {
        "circle-radius": 3,
        "circle-color": color,
      },
    },
    RawStyles: {
      Type: "circle",
      CircleRadius: 3,
      CircleColor: color,
    },
    Type: "STYLE",
  },
];

const streetsLayerStyles = (layerId: string, color: string): LayerStyle[] => [
  {
    ID: `${layerId}-line`,
    Name: `${layerId}-line`,
    GlobalPosition: 1,
    ConfigurationID: layerId,
    ConfigurationType: "LAYER",
    Position: 0,
    MapboxStyle: {
      type: "line",
      "source-layer": "default",
      paint: {
        "line-width": 2,
        "line-color": color,
      },
    },
    RawStyles: {
      Type: "line",
      LineColor: color,
      LineWidth: 2,
    },
    Type: "STYLE",
  },
];
